var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "view-toolbar",
          attrs: { color: "primary", dark: "", tabs: "", flat: "", dense: "" },
        },
        [
          !_vm.drawerState
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-app-bar-nav-icon",
                              _vm._g(
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("toggle-drawer")
                                    },
                                  },
                                },
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3579378334
                  ),
                },
                [_c("span", [_vm._v("Open side menu")])]
              )
            : _vm._e(),
          _c(
            "v-toolbar-title",
            [
              _vm._v(" " + _vm._s(_vm.toolbarTitle) + " "),
              _vm.wikiSection
                ? _c("WikiButton", { attrs: { section: _vm.wikiSection } })
                : _vm._e(),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-toolbar-items",
            [
              _vm.currentCase && _vm.currentCase.locked
                ? _c("v-icon", [_vm._v("mdi-lock")])
                : [
                    _c("v-hover", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var hover = ref.hover
                            return _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.showFloatingSaveBtn,
                                    expression: "!showFloatingSaveBtn",
                                  },
                                ],
                                attrs: {
                                  icon: "",
                                  color: hover ? "accent" : "",
                                  disabled: !_vm.hasChanged,
                                  loading: _vm.caseSavePending,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("save")
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("save")])],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c(
                      "MenuMore",
                      { attrs: { "offset-x": "", "offset-y": "" } },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                attrs: { color: "error" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("remove")
                                  },
                                },
                              },
                              [_vm._v(" Delete Case ")]
                            ),
                            _c(
                              "v-list-item",
                              { on: { click: _vm.removeAllMessages } },
                              [_vm._v(" Delete All Messages ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-fab-transition",
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFloatingSaveBtn && _vm.hasChanged,
                  expression: "showFloatingSaveBtn && hasChanged",
                },
              ],
              staticClass: "sticky-btn",
              attrs: {
                color: "primary",
                fab: "",
                small: "",
                absolute: "",
                right: "",
                loading: _vm.caseSavePending,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("save")
                },
              },
            },
            [_c("v-icon", [_vm._v("save")])],
            1
          ),
        ],
        1
      ),
      _vm.caseLoadPending
        ? _c("v-progress-linear", {
            staticClass: "mt-0",
            attrs: { indeterminate: true, color: "secondary" },
          })
        : _vm._e(),
      _c(
        "transition",
        [
          _c(
            "keep-alive",
            [
              _vm.currentCase
                ? _c(
                    _vm.page.component,
                    _vm._b(
                      {
                        tag: "component",
                        attrs: {
                          errors: _vm.errors,
                          num_years: _vm.num_years,
                          "start-year": _vm.currentCase.settings.year_start,
                          currentCase: _vm.currentCase,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                          save: function ($event) {
                            return _vm.$emit("save")
                          },
                        },
                      },
                      "component",
                      _vm.currentCase,
                      false,
                      true
                    )
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }